import { render, staticRenderFns } from "./LimitDialog.vue?vue&type=template&id=e30985b8&"
import script from "./LimitDialog.vue?vue&type=script&lang=js&"
export * from "./LimitDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports